import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../services/auth";
import { toast, ToastContainer } from "react-toastify";
import {useCombinedContext} from "../../context/CombinedContext";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("viewProfile");
  const {user,setUser} =useCombinedContext();
  // console.log("profile user",user);
  // const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [profileFormData, setProfileFormData] = useState({
    name: "",
    email: "",
    image: null,
  });
  const [passwordFormData, setPasswordFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get("/auth/profile");
        setUser(data.data);
        // console.log("data from use",data)
        setProfileFormData({ name: data.data.name, email: data.data.email });
        // console.log(data);
      } catch (error) {
        // console.error(
        //   error.response?.data?.message || "Error fetching profile"
        // );
        toast.error("Error fetching profile");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const handleProfileChange = (e) => {
    setProfileFormData({ ...profileFormData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setProfileFormData({ ...profileFormData, image: e.target.files[0] });
  };

  const updateProfile = async (e) => {
    e.preventDefault();

    // Create a new FormData object
    const data = new FormData();

    // Conditionally append data based on changes
    if (profileFormData.name !== user.name) {
      data.append("name", profileFormData.name);
    }
    if (profileFormData.email !== user.email) {
      data.append("email", profileFormData.email); // You might want to include email if needed
    }
    if (profileFormData.image) {
      data.append("image", profileFormData.image);
    }

    try {
      setLoadingButton(true);
      // Send the update request
      const response = await axiosInstance.put("/auth/profile-settings", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Update user state with the new values (if any)
      setUser({
        ...user,
        name: response.data.name || user.name, // Use new name if it was updated
        image: response.data.image || user.image, // Use new image if updated
      });

      // Switch back to the "viewProfile" tab
      setActiveTab("viewProfile");

      // Show success message
      toast.success(response.data.message);
    } catch (error) {
      // Handle error
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoadingButton(false); // Ensure button re-enables after request completion
    }
  };
  // const updateProfile = async (e) => {
  //   e.preventDefault();

  //   const data = new FormData();
  //   if (profileFormData.name !== user.name) {
  //     data.append("name", profileFormData.name);
  //   }
  //   if (profileFormData.image) {
  //     data.append("image", profileFormData.image);
  //   }

  //   try {
  //     const response = await axiosInstance.put("/auth/profile-settings", data, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     // Handle user state after successful update
  //     const updatedUserData = {
  //       ...user,
  //       name: response.data.name || user.name,
  //       image: response.data.image || user.image,
  //     };

  //     setUser(updatedUserData);
  //     toast.success(response.data.message);

  //     // Update localStorage or sessionStorage depending on the current token type
  //     const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  //     if (token) {
  //       const storageType = localStorage.getItem("authToken") ? localStorage : sessionStorage;
  //       storageType.setItem("authData", JSON.stringify(updatedUserData));
  //       // console.log("User data updated in local/sessionStorage");
  //     }
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || "Could not update profile");
  //   }
  // };

  const changePassword = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axiosInstance.post(
        "/auth/change-password",
        passwordFormData
      );

      setPasswordFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      toast.success(data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  

  return (
    <>
    {loading ? (
      <div className="d-flex justify-content-center m-3">
                   <div className="spinner"></div>
                 </div>
    ) :(
      <div className="container mt-2">
      <ToastContainer />
     <h3>User Profile</h3>
     <ul className="nav nav-tabs mb-4 d-flex  flex-row">
       <li className="nav-item">
         <button
           className={`nav-link ${
             activeTab === "viewProfile" ? "active" : ""
           }`}
           onClick={() => setActiveTab("viewProfile")}
         >
           View Profile
         </button>
       </li>
       <li className="nav-item">
         <button
           className={`nav-link ${
             activeTab === "updateProfile" ? "active" : ""
           }`}
           onClick={() => setActiveTab("updateProfile")}
         >
           Update Profile
         </button>
       </li>
       <li className="nav-item">
         <button
           className={`nav-link ${
             activeTab === "changePassword" ? "active" : ""
           }`}
           onClick={() => setActiveTab("changePassword")}
         >
           Change Password
         </button>
       </li>
     </ul>

     {activeTab === "viewProfile" && user && (
       <div
         className="card profile_form"
         style={{
           maxWidth: "300px",
           maxHeight: "500px",
           height: "100%",
           borderRadius: "10px",
           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
           transition: "all 0.3s ease",
         }}
       >
         <div className="card-body text-center">
           {user.image ? (
             <img
               src={`${axiosInstance.defaults.baseURL}/Uploads/${user.image}`}
               alt="Profile"
               className="img-thumbnail"
               style={{
                 width: "150px",
                 height: "150px",
                 borderRadius: "10px",
                 boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                 marginBottom: "20px",
               }}
             />
           ) : (
             <p>No Profile Image</p>
           )}
           <h5>{user.name || "NA"}</h5>
           <p>{user.email || "NA"}</p>
         </div>
       </div>
     )}

     {activeTab === "updateProfile" && (
       <form onSubmit={updateProfile} style={{ maxWidth: "400px" }}>
         <div className="mb-3">
           <label className="form-label">Name</label>
           <input
             type="text"
             name="name"
             className="form-control"
             value={profileFormData.name}
             onChange={handleProfileChange}
           />
         </div>
         <div className="mb-3">
           <label className="form-label">Email</label>
           <input
             type="email"
             name="email"
             className="form-control"
             value={profileFormData.email}
             onChange={handleProfileChange}
             disabled
           />
         </div>
         <div className="mb-3">
           <label className="form-label">Profile Image</label>
           <input
             type="file"
             className="form-control"
             style={{maxWidth:"200px"}}
             onChange={handleFileChange}
           />
         </div>
         <button type="submit" className="button-2" disabled={loadingButton}>
         {loadingButton ? "Updating..." : "Update Profile"}
         </button>
       </form>
     )}

     {activeTab === "changePassword" && (
       <form onSubmit={changePassword} style={{ maxWidth: "400px" }}>
         <div className="mb-3">
           <label className="form-label">Current Password</label>
           <input
             type="password"
             name="currentPassword"
             className="form-control"
             value={passwordFormData.currentPassword}
             onChange={(e) =>
               setPasswordFormData({
                 ...passwordFormData,
                 currentPassword: e.target.value,
               })
             }
             required
           />
         </div>
         <div className="mb-3">
           <label className="form-label">New Password</label>
           <input
             type="password"
             name="newPassword"
             className="form-control"
             value={passwordFormData.newPassword}
             onChange={(e) =>
               setPasswordFormData({
                 ...passwordFormData,
                 newPassword: e.target.value,
               })
             }
             required
           />
         </div>
         <div className="mb-3">
           <label className="form-label">Confirm Password</label>
           <input
             type="password"
             name="confirmPassword"
             className="form-control"
             value={passwordFormData.confirmPassword}
             onChange={(e) =>
               setPasswordFormData({
                 ...passwordFormData,
                 confirmPassword: e.target.value,
               })
             }
             required
           />
         </div>
         <button type="submit" className="button-2">
           Change Password
         </button>
       </form>
     )}
   </div>
    )}
    </>
    
  );
};

export default Profile;
